import React from 'react';
import SortByRefinement from './SortByRefinement';
import { baseConfig } from '../../../config/algolia';

const { sort_orders } = baseConfig;

interface SortByContainerProps {
  collection: any;
  indexName: string;
  defaultIndexLabel?: string;
  mobileShow: boolean;
  setMobileShowSort: any;
  searchTerm: string|undefined;
}

const SortByContainer = ({
  collection,
  indexName,
  defaultIndexLabel = 'Relevancy',
  mobileShow,
  setMobileShowSort,
  searchTerm,
}: SortByContainerProps) => {
  const sortOrders = [{ value: indexName, label: defaultIndexLabel }];

  sort_orders.forEach(sortOrder => {
    if (sortOrder.asc && sortOrder.asc.active) {
      sortOrders.push({
        value: `${indexName}_${sortOrder.key}_asc`,
        label: sortOrder.asc.title,
      });
    }
    if (sortOrder.desc && sortOrder.desc.active) {
      sortOrders.push({
        value: `${indexName}_${sortOrder.key}_desc`,
        label: sortOrder.desc.title,
      });
    }
  });

  const closeSort = () => {
    document.body.classList.remove('no-scroll');
    setMobileShowSort(false);
  };

  return (
    <div className={`sortby-container`}>
      <span className="sort-title">Sort by:</span>
      <SortByRefinement
        items={sortOrders}
        defaultRefinement={collection && collection.sortMethod ? indexName + collection.sortMethod : indexName}
        searchTerm={searchTerm}
      />
    </div>
  );
};

export default SortByContainer;
